// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1___ea7cca6bf3666dcc827","cls2":"Comment-cls2___2762eb56eec469f4914 Comment-cls1___ea7cca6bf3666dcc827"};